import { SearchQuery } from 'modules/domains';
import { SetCriteriaFn, useSetCriteria } from './useSetCriteria';
import { useCriteria } from './useCriteria';

export const useCriteriaState = (): [criteria: SearchQuery, setCriteria: SetCriteriaFn] => {
  const criteria = useCriteria();
  const setCriteria = useSetCriteria();
  return [criteria, setCriteria];
};
